var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form/Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M19.414 3.3409C19.6456 3.56238 19.8 3.8577 19.8 4.18992V12.5325C19.8 13.8614 18.6807 14.895 17.3298 14.895H9.9193C8.52982 14.895 7.44912 13.8614 7.41053 12.5325V3.0825C7.41053 1.79051 8.49123 0.720001 9.8807 0.720001H16.1719C16.5193 0.720001 16.8281 0.867657 17.0596 1.08914L19.414 3.3409ZM17.9474 12.5325H17.9088V5.445H16.0947C15.4 5.445 14.8596 4.9282 14.8596 4.26375L14.8211 2.52879H9.8807C9.53333 2.52879 9.26316 2.78719 9.26316 3.11942V12.5325C9.26316 12.8647 9.53333 13.1231 9.8807 13.1231H17.3298C17.6386 13.1231 17.9474 12.8647 17.9474 12.5325ZM10.5368 17.2575V16.0763H12.3895V17.2575C12.3895 18.5864 11.2702 19.62 9.9193 19.62H2.50877C1.1193 19.62 0.0385965 18.5864 0.0385965 17.2575L0 7.8075C0 6.51551 1.1193 5.445 2.47018 5.445H6.21404V7.25379H2.47018C2.1614 7.25379 1.85263 7.51219 1.85263 7.84442V17.2575C1.85263 17.5897 2.12281 17.8481 2.47018 17.8481H9.9193C10.2281 17.8481 10.5368 17.5897 10.5368 17.2575Z",
    fill: "#3E4D5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy-2.7426700f76ab1e22392627124c826ba0.svg";
export { ForwardRef as ReactComponent };